import { render, staticRenderFns } from "./task-rule-add-dialog.vue?vue&type=template&id=982aaf76&scoped=true"
import script from "./task-rule-add-dialog.vue?vue&type=script&lang=js"
export * from "./task-rule-add-dialog.vue?vue&type=script&lang=js"
import style0 from "./task-rule-add-dialog.vue?vue&type=style&index=0&id=982aaf76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "982aaf76",
  null
  
)

export default component.exports